const Action = {
  UserDownloadedPdf: 'user_downloaded_pdf',
  UserLoggedIn: 'user_logged_in',
  CulturalAnalysesPdfDownloaded: 'cultural_analyses_pdf_downloaded',
  MatchesViewModeSelected: 'matches_view_mode_selected',
  B2BSimplifiedCultureQuestionnaireStarted: 'b2b_simplified_culture_questionnaire_started',
  B2BBookAppointmentClicked: 'b2b_book_appointment_clicked',
};

const Category = {
  ApplicantPdf: 'applicant_pdf',
  Applicant: 'applicant',
  Company: 'company',
  MatchesPage: 'matches_page',
  Marketing: 'marketing',
};

const Group = {
  Company: 'company',
};

const Version = {
  v0: 'v0',
  v1: 'v1',
};

export const TrackingEvents = {
  Action,
  Category,
  Group,
  Version,
} as const;
